module.exports = __webpack_public_path__ + "assets/img/sabc_tv_schedule_sabc1.svg?a63fb355e0ca1ea99f470331464b6415";